import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet, useHasPermission } from '../hooks';
import { Flag, Fleet } from '../interfaces';
import { EventsService } from '../services';

export const useFlagsQuery = () => {
  const fleet = useFleet();
  const queryKey = ['flags', fleet.id];
  const hasPermission = useHasPermission('events:read:flag');

  const queryFn = () => EventsService.getFlags();
  return useQuery({
    queryKey,
    queryFn,
    defaultData: [] as Flag[],
    enabled: hasPermission,
  });
};

export const refreshFlags = (fleetId: Fleet['id']) => {
  queryClient.invalidateQueries(['flags', fleetId]);
};
